<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Highway Project Management System</title>
<link href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=DM+Mono:wght@400;500&display=swap" rel="stylesheet">
<style>
/* ═══════════════════════════════════════════
   DESIGN SYSTEM — Highway Project Management
   Industrial-Precision · Data-Dense · Dark Nav
   ═══════════════════════════════════════════ */
:root {
  --navy:        #1e2d4a;
  --navy-dark:   #162039;
  --navy-mid:    #243555;
  --navy-light:  #2e4268;
  --panel-bg:    #f4f6f9;
  --panel-white: #ffffff;
  --border:      #d0d8e8;
  --border-dark: #b8c4d8;
  --text-h:      #1a2540;
  --text-body:   #374151;
  --text-muted:  #6b7a8f;
  --text-nav:    #c8d8f0;
  --accent-blue:  #2563eb;
  --accent-cyan:  #0891b2;
  --accent-green: #16a34a;
  --accent-orange:#d97706;
  --accent-red:   #dc2626;
  --accent-amber: #f59e0b;
  --nhai-gold:    #f5a623;
  --progress-h:   6px;
  --radius-sm:    3px;
  --radius:       5px;
  --radius-lg:    8px;
  --shadow-sm:    0 1px 3px rgba(0,0,0,0.1);
  --shadow:       0 2px 8px rgba(0,0,0,0.12);
  --shadow-lg:    0 4px 16px rgba(0,0,0,0.15);
  --font: 'DM Sans', sans-serif;
  --mono: 'DM Mono', monospace;
}

* { margin:0; padding:0; box-sizing:border-box; }

html, body {
  height: 100%;
  font-family: var(--font);
  font-size: 12px;
  color: var(--text-body);
  background: var(--panel-bg);
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
}
/* ══ TOPBAR ══ */
.topbar {
  height: 48px;
  background: linear-gradient(90deg, #162039 0%, #1e2d4a 40%, #243a60 100%);
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 12px;
  flex-shrink: 0;
  position: relative;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.topbar::after {
  content:'';
  position:absolute;
  bottom:0;left:0;right:0;height:2px;
  background: linear-gradient(90deg, var(--nhai-gold) 0%, #f0c060 30%, transparent 70%);
}

.topbar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 8px;
}
.logo-emblem {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}
.topbar-title {
  font-size: 18px;
  font-weight: 300;
  color: #fff;
  letter-spacing: -0.01em;
  line-height: 1;
  white-space: nowrap;
}
.topbar-title strong { font-weight: 700; }

.topbar-search {
  margin-left: auto;
  display: flex;
  align-items: center;
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 20px;
  padding: 5px 12px;
  gap: 7px;
  width: 200px;
  transition: all 0.2s;
}
.topbar-search:focus-within {
  background: rgba(255,255,255,0.15);
  border-color: rgba(255,255,255,0.3);
  width: 240px;
}
.topbar-search input {
  background: none;
  border: none;
  outline: none;
  color: rgba(255,255,255,0.9);
  font-family: var(--font);
  font-size: 12px;
  width: 100%;
}
.topbar-search input::placeholder { color: rgba(255,255,255,0.45); }
.topbar-search svg { color: rgba(255,255,255,0.5); flex-shrink:0; }

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 10px;
}
.topbar-icon-btn {
  width: 32px; height: 32px;
  border-radius: 50%;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.12);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  color: rgba(255,255,255,0.7);
  transition: all 0.15s;
}
.topbar-icon-btn:hover { background: rgba(255,255,255,0.15); color: #fff; }
.topbar-icon-btn svg { width:15px; height:15px; }

/* ══ PROJECT BAR ══ */
.project-bar {
  height: 38px;
  background: #fff;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 6px;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}
.project-bar-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-h);
  margin-right: 6px;
}
.project-bar-title span { font-weight: 300; color: var(--text-muted); }

.pbar-btn {
  display: flex; align-items: center; gap: 4px;
  padding: 4px 9px;
  font-size: 11px;
  font-weight: 500;
  color: var(--text-body);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.12s;
  white-space: nowrap;
  font-family: var(--font);
}
.pbar-btn:hover { background: var(--panel-bg); border-color: var(--border); }
.pbar-btn svg { width: 12px; height: 12px; color: var(--text-muted); }
.pbar-sep { width: 1px; height: 18px; background: var(--border); margin: 0 3px; }
.pbar-spacer { flex: 1; }

/* ══ BODY LAYOUT ══ */
.body-layout {
  display: flex;
  height: calc(100vh - 48px - 38px);
  overflow: hidden;
}

/* ══ LEFT NAV ══ */
.left-nav {
  width: 148px;
  background: linear-gradient(180deg, #1e2d4a 0%, #162039 100%);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.stage-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 12px 6px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}
.stage-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--nhai-gold);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.stage-arrow { color: rgba(255,255,255,0.4); font-size: 10px; }

.nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 400;
  color: rgba(200,216,240,0.75);
  cursor: pointer;
  transition: all 0.12s;
  border-left: 2px solid transparent;
  border-bottom: 1px solid rgba(255,255,255,0.04);
  position: relative;
}
.nav-item:hover { background: rgba(255,255,255,0.06); color: #fff; }
.nav-item.active {
  background: rgba(37,99,235,0.2);
  color: #fff;
  border-left-color: var(--accent-blue);
  font-weight: 600;
}
.nav-item .ni-icon {
  width: 16px; height: 16px;
  flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  opacity: 0.8;
}
.nav-item.active .ni-icon { opacity: 1; }
.nav-item .ni-arrow { margin-left: auto; font-size: 9px; color: rgba(255,255,255,0.3); }

/* Layer Control */
.layer-control-header {
  padding: 10px 12px 5px;
  font-size: 10px;
  font-weight: 700;
  color: var(--nhai-gold);
  text-transform: uppercase;
  letter-spacing: 0.07em;
}
.layer-item {
  display: flex; align-items: center; gap: 6px;
  padding: 4px 12px;
  font-size: 10px;
  color: rgba(200,216,240,0.75);
  cursor: pointer;
}
.layer-item:hover { color: #fff; }
.layer-check {
  width: 12px; height: 12px;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 2px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(37,99,235,0.4);
  flex-shrink: 0;
  font-size: 8px;
  color: #fff;
}
.layer-check.road { background: rgba(37,99,235,0.5); }
.layer-check.road-tick { margin-left: auto; font-size: 10px; color: var(--nhai-gold); }

/* Map Tools */
.map-tools-header {
  display: flex; align-items: center; gap: 6px;
  padding: 8px 12px 6px;
  font-size: 10px;
  font-weight: 700;
  color: var(--nhai-gold);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  border-top: 1px solid rgba(255,255,255,0.08);
  margin-top: auto;
}
.map-tools-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2px;
  padding: 0 10px 10px;
}
.map-tool-btn {
  display: flex; flex-direction: column; align-items: center; gap: 3px;
  padding: 6px 2px;
  border-radius: var(--radius-sm);
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  cursor: pointer;
  transition: all 0.12s;
}
.map-tool-btn:hover { background: rgba(255,255,255,0.1); }
.map-tool-btn span { font-size: 8px; color: rgba(200,216,240,0.6); }
.map-tool-btn svg { width: 14px; height: 14px; color: rgba(200,216,240,0.7); }

/* ══ MAP CENTER ══ */
.map-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  border-right: 1px solid var(--border);
  overflow: hidden;
}

/* Map toolbar */
.map-toolbar {
  height: 34px;
  background: var(--panel-white);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  padding: 0 8px;
  gap: 3px;
  flex-shrink: 0;
}
.mt-btn {
  display: flex; align-items: center; gap: 3px;
  padding: 3px 7px;
  font-size: 10px; font-weight: 500;
  color: var(--text-muted);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.1s;
  white-space: nowrap;
  font-family: var(--font);
}
.mt-btn:hover { background: var(--panel-bg); border-color: var(--border); color: var(--text-body); }
.mt-btn.active { background: #e8eef8; border-color: #b8cce8; color: var(--accent-blue); font-weight: 600; }
.mt-sep { width: 1px; height: 16px; background: var(--border); margin: 0 2px; }
.mt-icon-btn {
  width: 26px; height: 26px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  color: var(--text-muted);
  transition: all 0.1s;
}
.mt-icon-btn:hover { background: var(--panel-bg); color: var(--text-body); }

/* Map canvas */
.map-canvas {
  flex: 1;
  position: relative;
  overflow: hidden;
  background: #e8eef5;
}

/* OSM-style tile background */
.map-tiles {
  position: absolute; inset: 0;
  background-color: #e8eef5;
  background-image:
    /* Streets grid faint */
    linear-gradient(rgba(180,195,215,0.3) 1px, transparent 1px),
    linear-gradient(90deg, rgba(180,195,215,0.3) 1px, transparent 1px);
  background-size: 40px 40px;
}

/* Map attribution */
.map-attr {
  position: absolute;
  bottom: 4px; left: 8px;
  font-size: 8px;
  color: rgba(0,0,0,0.35);
  background: rgba(255,255,255,0.7);
  padding: 1px 5px;
  border-radius: 2px;
}

/* Map zoom controls */
.map-zoom {
  position: absolute;
  right: 10px; top: 10px;
  display: flex; flex-direction: column;
  gap: 2px;
}
.zoom-btn {
  width: 28px; height: 28px;
  background: var(--panel-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; font-weight: 300;
  cursor: pointer; color: var(--text-body);
  box-shadow: var(--shadow-sm);
  transition: all 0.1s;
}
.zoom-btn:hover { background: var(--panel-bg); }

/* Map action buttons (layer/location) */
.map-side-btns {
  position: absolute;
  right: 10px; bottom: 80px;
  display: flex; flex-direction: column; gap: 4px;
}
.map-action-btn {
  width: 32px; height: 32px;
  background: var(--panel-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  color: var(--text-muted);
  transition: all 0.1s;
}
.map-action-btn:hover { color: var(--accent-blue); }

/* ══ MAP SVG CONTENT ══ */
.map-svg-overlay {
  position: absolute; inset: 0;
  width: 100%; height: 100%;
  pointer-events: none;
}

/* Chainage label chips */
.ch-chip {
  position: absolute;
  background: rgba(255,255,255,0.9);
  border: 1px solid rgba(37,99,235,0.4);
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 700;
  color: var(--accent-blue);
  font-family: var(--mono);
  white-space: nowrap;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  cursor: default;
}
.ch-chip::before {
  content: '';
  position: absolute;
  bottom: -5px; left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: rgba(37,99,235,0.5);
  border-bottom: none;
}

/* NH Route label */
.nh-label {
  position: absolute;
  background: rgba(245,166,35,0.9);
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid rgba(245,166,35,0.6);
  letter-spacing: 0.05em;
}

/* Equipment markers */
.equip-marker {
  position: absolute;
  width: 20px; height: 20px;
  cursor: pointer;
}

/* ══ BOTTOM PANELS ══ */
.bottom-panels {
  height: 110px;
  border-top: 1px solid var(--border);
  display: flex;
  flex-shrink: 0;
  background: var(--panel-white);
}

.bottom-card {
  flex: 1;
  border-right: 1px solid var(--border);
  padding: 9px 12px;
  overflow: hidden;
}
.bottom-card:last-child { border-right: none; }

.bc-header {
  display: flex; align-items: center; gap: 5px;
  margin-bottom: 7px;
  font-size: 11px;
  font-weight: 700;
  color: var(--text-h);
}
.bc-badge {
  width: 16px; height: 16px;
  border-radius: 50%;
  background: var(--accent-blue);
  color: #fff;
  font-size: 8px;
  font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}

.contractor-row {
  display: flex; align-items: center; gap: 6px;
  padding: 3px 0;
  font-size: 11px;
}
.contractor-avatar {
  width: 22px; height: 22px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 9px; font-weight: 700; color: #fff;
  flex-shrink: 0;
}

/* Weather card */
.weather-display {
  display: flex; align-items: center; gap: 10px;
  padding: 4px 0;
}
.weather-temp {
  font-size: 26px;
  font-weight: 300;
  color: var(--text-h);
  line-height: 1;
  font-family: var(--mono);
}
.weather-temp sup { font-size: 12px; font-weight: 500; vertical-align: super; }
.weather-detail {
  font-size: 10px;
  color: var(--text-muted);
  line-height: 1.6;
}

/* Alert card */
.alert-item {
  display: flex; align-items: flex-start; gap: 5px;
  padding: 3px 0;
  font-size: 10px;
  line-height: 1.4;
  color: var(--text-body);
  border-bottom: 1px solid var(--border);
}
.alert-item:last-child { border-bottom: none; }
.alert-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 3px;
}

/* ══ STATUS BAR ══ */
.status-bar {
  height: 22px;
  background: var(--navy-dark);
  display: flex;
  align-items: center;
  padding: 0 10px;
  gap: 14px;
  flex-shrink: 0;
}
.sb-item {
  display: flex; align-items: center; gap: 5px;
  font-size: 9px;
  color: rgba(200,216,240,0.6);
  font-family: var(--mono);
}
.sb-dot { width: 6px; height: 6px; border-radius: 50%; }
.sb-dot.connected { background: var(--accent-green); box-shadow: 0 0 5px rgba(22,163,74,0.5); }
.sb-spacer { flex: 1; }
.sb-bar {
  height: 8px;
  background: rgba(255,255,255,0.1);
  border-radius: 1px;
  overflow: hidden;
  display: flex;
}
.sb-bar-fill { background: rgba(37,99,235,0.7); }
.sb-ticks {
  display: flex; gap: 1px;
  align-items: center;
}
.sb-tick { width: 3px; height: 8px; background: rgba(255,255,255,0.2); border-radius: 1px; }

/* ══ RIGHT PANEL ══ */
.right-panel {
  width: 268px;
  display: flex;
  flex-direction: column;
  background: var(--panel-white);
  flex-shrink: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.rp-header {
  padding: 10px 14px 8px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.rp-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-h);
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rp-title-actions { display: flex; gap: 4px; }
.rp-icon-btn {
  width: 20px; height: 20px;
  background: var(--panel-bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  color: var(--text-muted);
  font-size: 9px;
}

/* Tabs */
.rp-tabs {
  display: flex;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.rp-tab {
  flex: 1;
  padding: 7px 4px;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.12s;
}
.rp-tab:hover { color: var(--text-body); }
.rp-tab.active {
  color: var(--accent-blue);
  border-bottom-color: var(--accent-blue);
}

/* Progress section */
.rp-section { padding: 10px 14px; border-bottom: 1px solid var(--border); }

.rp-project-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-h);
  margin-bottom: 5px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.rp-pct {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-h);
  line-height: 1;
  font-family: var(--mono);
}
.rp-pct-label { font-size: 9px; color: var(--text-muted); }

.progress-bar {
  height: var(--progress-h);
  background: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 3px;
}
.progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.8s cubic-bezier(0.4,0,0.2,1);
}

.planning-row {
  display: flex; align-items: center; justify-content: space-between;
  font-size: 10px;
}
.planning-label { color: var(--text-muted); }
.planning-dots { display: flex; gap: 3px; }
.planning-dot { width: 10px; height: 10px; border-radius: 50%; border: 1.5px solid var(--border); cursor: pointer; }
.planning-dot.filled { background: var(--accent-blue); border-color: var(--accent-blue); }

/* Summary table */
.summary-table { width: 100%; border-collapse: collapse; }
.summary-table td {
  padding: 3px 0;
  font-size: 11px;
  border-bottom: 1px solid rgba(208,216,232,0.5);
}
.summary-table td:first-child { color: var(--text-muted); font-weight: 500; padding-right: 6px; }
.summary-table td:last-child { text-align: right; font-weight: 600; color: var(--text-h); font-family: var(--mono); font-size: 10px; }
.summary-table tr:last-child td { border-bottom: none; }

/* Progress bars section */
.prog-row {
  display: flex; align-items: center; gap: 7px;
  padding: 3px 0;
}
.prog-label { font-size: 10px; color: var(--text-muted); min-width: 70px; }
.prog-bar-wrap { flex: 1; height: 5px; background: #e5e7eb; border-radius: 3px; overflow: hidden; }
.prog-bar-fill { height: 100%; border-radius: 3px; }
.prog-pct { font-size: 9px; font-weight: 700; color: var(--text-h); min-width: 24px; text-align: right; font-family: var(--mono); }

/* Mini chart */
.mini-chart { height: 80px; position: relative; overflow: hidden; }
.mc-x-labels {
  display: flex; justify-content: space-between;
  padding: 0 2px;
  font-size: 8px;
  color: var(--text-muted);
  font-family: var(--mono);
  margin-top: 2px;
}

/* ═══ ANIMATIONS ═══ */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes pulseMarker {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(1.3); }
}

.body-layout > * { animation: fadeInUp 0.3s ease both; }
.right-panel { animation-delay: 0.08s; }
.left-nav { animation-delay: 0.04s; }
.map-center { animation-delay: 0.06s; }

/* Scrollbar styling */
::-webkit-scrollbar { width: 4px; height: 4px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 2px; }
</style>
</head>
<body>
<!-- ══════════════ TOPBAR ══════════════ -->
<header class="topbar">
    <div class="topbar-logo">
      <!-- NHAI-style highway emblem -->
      <svg class="logo-emblem" viewBox="0 0 36 36">
        <circle cx="18" cy="18" r="17" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" stroke-width="1"/>
        <path d="M6,14 Q10,8 18,8 Q26,8 30,14" stroke="#f5a623" stroke-width="2.5" fill="none" stroke-linecap="round"/>
        <path d="M6,22 Q10,28 18,28 Q26,28 30,22" stroke="#f5a623" stroke-width="2.5" fill="none" stroke-linecap="round"/>
        <line x1="18" y1="6" x2="18" y2="30" stroke="rgba(255,255,255,0.4)" stroke-width="1.5" stroke-dasharray="3,2"/>
        <line x1="4" y1="18" x2="32" y2="18" stroke="rgba(255,255,255,0.3)" stroke-width="1"/>
      </svg>
      <div class="topbar-title"><strong>Highway Project</strong> Management System</div>
    </div>
  
    <div class="topbar-search">
      <svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="6.5" cy="6.5" r="5"/><path d="m10.5 10.5 3.5 3.5"/>
      </svg>
      <input type="text" placeholder="Search…">
      <svg viewBox="0 0 16 16" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="6.5" cy="6.5" r="5"/><path d="m10.5 10.5 3.5 3.5"/>
      </svg>
    </div>
  
    <div class="topbar-actions">
      <!-- Chat -->
      <div class="topbar-icon-btn" title="Messages">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4l2 3 2-3h4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z"/></svg>
      </div>
      <!-- Notifications -->
      <div class="topbar-icon-btn" title="Notifications">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 2a5 5 0 0 0-5 5v3L2 11h12l-1-1V7a5 5 0 0 0-5-5Z"/><path d="M6.5 13.5a1.5 1.5 0 0 0 3 0"/></svg>
      </div>
      <!-- Settings -->
      <div class="topbar-icon-btn" title="Settings">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="8" cy="8" r="2.5"/><path d="M8 2v1M8 13v1M2 8h1M13 8h1M3.5 3.5l.7.7M11.8 11.8l.7.7M3.5 12.5l.7-.7M11.8 4.2l.7-.7"/></svg>
      </div>
      <!-- Power -->
      <div class="topbar-icon-btn" title="Logout">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2a6 6 0 1 0 4 0"/><line x1="8" y1="1" x2="8" y2="8"/></svg>
      </div>
    </div>
  </header>
  
  <!-- ══════════════ PROJECT BAR ══════════════ -->
  <div class="project-bar">
    <div class="project-bar-title">Project Planning <span>Dashboard</span></div>
  
    <div class="pbar-btn">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="1" width="4" height="4" rx="0.5"/><rect x="7" y="1" width="4" height="4" rx="0.5"/><rect x="1" y="7" width="4" height="4" rx="0.5"/><rect x="7" y="7" width="4" height="4" rx="0.5"/></svg>
      Select
    </div>
    <div class="pbar-btn">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 10 L10 2"/><path d="M6 2 L10 2 L10 6"/></svg>
      Draw
    </div>
    <div class="pbar-btn">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 2 L10 4 L4 10 L2 10 L2 8 Z"/></svg>
      Edit
    </div>
    <div class="pbar-btn">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M1 6 L11 6"/><path d="M1 6 L3 4"/><path d="M1 6 L3 8"/><path d="M11 6 L9 4"/><path d="M11 6 L9 8"/></svg>
      Chainage
    </div>
    <div class="pbar-btn">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="2" width="10" height="8" rx="1"/><path d="M1 5h10"/><path d="M4 2v3"/><path d="M8 2v3"/></svg>
      Reports
    </div>
    <div class="pbar-btn">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 1v7"/><path d="M3 5l3 3 3-3"/><rect x="1" y="9" width="10" height="2" rx="0.5"/></svg>
      Import
    </div>
    <div class="pbar-btn">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 8V1"/><path d="M3 4L6 1l3 3"/><rect x="1" y="9" width="10" height="2" rx="0.5"/></svg>
      Export
    </div>
    <div class="pbar-sep"></div>
    <div class="pbar-btn" style="color:var(--accent-blue);font-weight:600;">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="6" cy="6" r="5"/><circle cx="6" cy="6" r="2"/><path d="M6 1 v1 M6 10 v1 M1 6 h1 M10 6 h1"/></svg>
      Satellite
    </div>
    <div class="pbar-btn">DEM</div>
    <div class="pbar-btn" style="color:var(--accent-blue);font-weight:600;">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="1" width="10" height="10" rx="1"/></svg>
      2D
    </div>
    <div class="pbar-btn">3D</div>
  </div>
  
  <!-- ══════════════ BODY ══════════════ -->
  <div class="body-layout">
  
    <!-- ════ LEFT NAV ════ -->
    <nav class="left-nav">
      <div class="stage-header">
        <span class="stage-label">⇌ Stage</span>
        <span class="stage-arrow">↑</span>
      </div>
  
      <div class="nav-item">
        <div class="ni-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 3h10M2 7h10M2 11h6"/></svg>
        </div>
        Pre-Bidding
      </div>
      <div class="nav-item">
        <div class="ni-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 12V6l5-4 5 4v6"/><rect x="5" y="8" width="4" height="4"/></svg>
        </div>
        Bidding
      </div>
      <div class="nav-item">
        <div class="ni-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M7 2l1.5 4h4l-3 2.5 1 4L7 10l-3.5 2.5 1-4L1.5 6h4Z"/></svg>
        </div>
        Field Survey
      </div>
      <div class="nav-item active">
        <div class="ni-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="2" width="12" height="10" rx="1"/><path d="M1 5h12"/><path d="M5 2v3"/><path d="M9 2v3"/></svg>
        </div>
        Planning
        <span class="ni-arrow">›</span>
      </div>
      <div class="nav-item">
        <div class="ni-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="4" cy="10" r="2"/><circle cx="10" cy="4" r="2"/><path d="M4 8V4h4"/></svg>
        </div>
        Execution
      </div>
      <div class="nav-item">
        <div class="ni-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 7h10M6 3l4 4-4 4"/></svg>
        </div>
        QA / QC
      </div>
      <div class="nav-item">
        <div class="ni-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 7h8M3 4h8M3 10h5"/></svg>
        </div>
        Billing
      </div>
      <div class="nav-item">
        <div class="ni-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 5h10l-1 7H3Z"/><path d="M5 5V3a2 2 0 0 1 4 0v2"/></svg>
        </div>
        ROW Acquistion
      </div>
  
      <!-- Layer Control -->
      <div class="layer-control-header">Layer Control</div>
  
      <div class="layer-item">
        <div class="layer-check road">✓</div>
        <span>Roads</span>
        <span class="layer-check road-tick" style="margin-left:auto;background:transparent;border:none;color:var(--nhai-gold);">✓</span>
      </div>
      <div class="layer-item">
        <div class="layer-check">✓</div>
        <span>New Aligment</span>
      </div>
      <div class="layer-item">
        <div class="layer-check">✓</div>
        <span>Survey Points</span>
      </div>
      <div class="layer-item">
        <div class="layer-check">✓</div>
        <span>Structures</span>
      </div>
      <div class="layer-item">
        <div class="layer-check">✓</div>
        <span>Land Parcels</span>
      </div>
      <div class="layer-item" style="margin-bottom:auto;">
        <div class="layer-check">✓</div>
        <span>Machines</span>
      </div>
  
      <!-- Map Tools -->
      <div class="map-tools-header">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="6" cy="6" r="5"/><path d="M6 2v2M6 8v2M2 6h2M8 6h2"/></svg>
        Map Tools
      </div>
      <div class="map-tools-grid">
        <div class="map-tool-btn">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="1" width="5" height="5" rx="0.5"/><rect x="8" y="1" width="5" height="5" rx="0.5"/><rect x="1" y="8" width="5" height="5" rx="0.5"/><rect x="8" y="8" width="5" height="5" rx="0.5"/></svg>
          <span>Select</span>
        </div>
        <div class="map-tool-btn">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 2L12 4L5 11L2 12L3 9Z"/></svg>
          <span>Draw</span>
        </div>
        <div class="map-tool-btn">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 3L11 5L5 11H3V9L9 3Z"/></svg>
          <span>Edit</span>
        </div>
        <div class="map-tool-btn">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="4" cy="7" r="2"/><circle cx="10" cy="7" r="2"/><line x1="6" y1="7" x2="8" y2="7"/></svg>
          <span>Snap</span>
        </div>
      </div>
    </nav>
  
    <!-- ════ MAP CENTER ════ -->
    <div class="map-center">
  
      <!-- Map toolbar -->
      <div class="map-toolbar">
        <div class="mt-btn active">🗺 2D</div>
        <div class="mt-btn">3D</div>
        <div class="mt-sep"></div>
        <div class="mt-btn" style="color:var(--accent-green);font-weight:600;background:#e8f5ed;border-color:#b4d9be;">✅ Sat</div>
        <div class="mt-sep"></div>
        <div class="mt-btn">📏 Snap</div>
        <div class="mt-btn">⚡ Measure</div>
        <div class="mt-sep"></div>
        <!-- icon group -->
        <div class="mt-icon-btn" title="Layer panel">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="3" width="10" height="2" rx="0.5"/><rect x="1" y="6.5" width="10" height="2" rx="0.5"/><rect x="1" y="10" width="10" height="2" rx="0.5"/></svg>
        </div>
        <div class="mt-icon-btn" title="Table view">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="1" width="4" height="4" rx="0.5"/><rect x="7" y="1" width="4" height="4" rx="0.5"/><rect x="1" y="7" width="4" height="4" rx="0.5"/><rect x="7" y="7" width="4" height="4" rx="0.5"/></svg>
        </div>
        <div class="mt-icon-btn" title="Split view">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="1" width="4" height="10" rx="0.5"/><rect x="7" y="1" width="4" height="10" rx="0.5"/></svg>
        </div>
        <div class="mt-icon-btn" title="Camera">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="3" width="10" height="7" rx="1"/><circle cx="6" cy="6.5" r="2"/><path d="M4 3 L4 2 L8 2 L8 3"/></svg>
        </div>
        <div class="mt-sep"></div>
        <div class="mt-icon-btn" title="Settings">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="6" cy="6" r="2"/><path d="M6 1v1M6 10v1M1 6h1M10 6h1M2.5 2.5l.7.7M8.8 8.8l.7.7M2.5 9.5l.7-.7M8.8 3.2l.7-.7"/></svg>
        </div>
        <div class="mt-icon-btn" title="Text">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 3h8M6 3v7"/></svg>
        </div>
        <div class="mt-icon-btn" title="More">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor"><circle cx="2" cy="6" r="1.2"/><circle cx="6" cy="6" r="1.2"/><circle cx="10" cy="6" r="1.2"/></svg>
        </div>
      </div>
  
      <!-- MAP CANVAS -->
      <div class="map-canvas">
        <div class="map-tiles"></div>
      <!-- ══ FULL MAP SVG ══ -->
      <svg class="map-svg-overlay" viewBox="0 0 700 420" preserveAspectRatio="xMidYMid meet">
        <!-- ── Roads background ── -->
        <!-- Major roads - light gray -->
        <path d="M0,140 Q80,135 160,130 Q240,125 320,120 Q400,115 480,118 Q560,121 700,115"
              stroke="#d8d8c0" stroke-width="14" fill="none"/>
        <path d="M0,140 Q80,135 160,130 Q240,125 320,120 Q400,115 480,118 Q560,121 700,115"
              stroke="#ece8d8" stroke-width="10" fill="none"/>

        <!-- Cross roads -->
        <path d="M200,0 Q198,80 195,160 Q193,240 190,320 Q188,380 186,420"
              stroke="#d8d8c0" stroke-width="8" fill="none"/>
        <path d="M200,0 Q198,80 195,160 Q193,240 190,320 Q188,380 186,420"
              stroke="#ece8d8" stroke-width="5" fill="none"/>

        <path d="M350,0 Q348,100 345,200 Q343,300 340,420"
              stroke="#d8d8c0" stroke-width="6" fill="none"/>

        <!-- Secondary road network -->
        <path d="M0,200 Q100,195 200,190 Q300,185 400,188 Q500,191 700,185"
              stroke="#e0ddd0" stroke-width="5" fill="none"/>
        <path d="M0,260 Q150,256 300,252 Q450,248 700,245"
              stroke="#e0ddd0" stroke-width="4" fill="none"/>
        <path d="M0,320 Q200,318 400,316 Q550,315 700,313"
              stroke="#e0ddd0" stroke-width="3" fill="none"/>

        <!-- Urban block fill areas -->
        <rect x="60" y="150" width="60" height="45" rx="2" fill="rgba(200,205,215,0.5)"/>
        <rect x="130" y="155" width="40" height="35" rx="2" fill="rgba(200,205,215,0.4)"/>
        <rect x="210" y="160" width="55" height="40" rx="2" fill="rgba(200,205,215,0.5)"/>
        <rect x="400" y="125" width="70" height="50" rx="2" fill="rgba(200,205,215,0.45)"/>
        <rect x="480" y="130" width="50" height="40" rx="2" fill="rgba(200,205,215,0.4)"/>
        <rect x="550" y="120" width="80" height="55" rx="2" fill="rgba(200,205,215,0.35)"/>
        <rect x="60" y="220" width="80" height="55" rx="2" fill="rgba(200,205,215,0.3)"/>
        <rect x="300" y="230" width="60" height="45" rx="2" fill="rgba(200,205,215,0.35)"/>
        <rect x="420" y="240" width="80" height="50" rx="2" fill="rgba(200,205,215,0.3)"/>

        <!-- Water body -->
        <ellipse cx="280" cy="310" rx="70" ry="25" fill="rgba(170,200,230,0.5)" stroke="rgba(100,160,210,0.3)" stroke-width="1"/>
        <ellipse cx="280" cy="310" rx="50" ry="16" fill="rgba(170,200,230,0.3)"/>

        <!-- Green patches -->
        <ellipse cx="160" cy="360" rx="55" ry="30" fill="rgba(180,210,160,0.45)"/>
        <ellipse cx="480" cy="340" rx="65" ry="28" fill="rgba(180,210,160,0.4)"/>

        <!-- ── NH-48 Highway — main route ── -->
        <!-- ROW corridor -->
        <path d="M10,280 Q80,258 160,248 Q260,236 360,232 Q460,228 560,238 Q620,242 695,248"
              stroke="rgba(245,166,35,0.2)" stroke-width="26" fill="none" stroke-linecap="round"/>

        <!-- Highway casing -->
        <path d="M10,280 Q80,258 160,248 Q260,236 360,232 Q460,228 560,238 Q620,242 695,248"
              stroke="#b89030" stroke-width="8" fill="none" stroke-linecap="round"/>
        <!-- Highway main fill -->
        <path d="M10,280 Q80,258 160,248 Q260,236 360,232 Q460,228 560,238 Q620,242 695,248"
              stroke="#f5c842" stroke-width="5" fill="none" stroke-linecap="round"/>
        <!-- Centre line -->
        <path d="M10,280 Q80,258 160,248 Q260,236 360,232 Q460,228 560,238 Q620,242 695,248"
              stroke="rgba(255,255,255,0.7)" stroke-width="1.5" fill="none" stroke-dasharray="14,8" stroke-linecap="round"/>

        <!-- ── New Alignment (proposed) ── -->
        <path d="M10,286 Q80,266 160,255 Q260,242 360,238 Q460,234 560,244 Q625,249 695,254"
              stroke="rgba(220,60,40,0.6)" stroke-width="3" fill="none" stroke-linecap="round" stroke-dasharray="10,5"/>

        <!-- ── Survey points ── -->
        <circle cx="160" cy="248" r="5" fill="#2563eb" stroke="white" stroke-width="2"/>
        <circle cx="280" cy="237" r="5" fill="#2563eb" stroke="white" stroke-width="2"/>
        <circle cx="390" cy="232" r="5" fill="#f59e0b" stroke="white" stroke-width="2"/>
        <circle cx="500" cy="236" r="5" fill="#2563eb" stroke="white" stroke-width="2"/>
        <circle cx="600" cy="242" r="5" fill="#16a34a" stroke="white" stroke-width="2"/>

        <!-- Equipment markers (excavators) -->
        <!-- Excavator 1 -->
        <g transform="translate(300,220)">
          <rect x="-8" y="-8" width="16" height="16" rx="2" fill="rgba(245,166,35,0.9)" stroke="rgba(200,120,0,0.8)" stroke-width="1"/>
          <text x="0" y="4" text-anchor="middle" font-size="10" fill="#5a3000">⚙</text>
        </g>
        <!-- Excavator 2 -->
        <g transform="translate(430,235)">
          <rect x="-8" y="-8" width="16" height="16" rx="2" fill="rgba(245,166,35,0.9)" stroke="rgba(200,120,0,0.8)" stroke-width="1"/>
          <text x="0" y="4" text-anchor="middle" font-size="10" fill="#5a3000">⚙</text>
        </g>
        <!-- Roller -->
        <g transform="translate(530,240)">
          <rect x="-8" y="-8" width="16" height="16" rx="2" fill="rgba(220,60,30,0.85)" stroke="rgba(180,40,20,0.8)" stroke-width="1"/>
          <text x="0" y="4" text-anchor="middle" font-size="9" fill="white">🔧</text>
        </g>

        <!-- Active survey point ring -->
        <circle cx="390" cy="232" r="12" fill="none" stroke="rgba(245,159,11,0.4)" stroke-width="2">
          <animate attributeName="r" values="8;16;8" dur="2.5s" repeatCount="indefinite"/>
          <animate attributeName="opacity" values="0.8;0.2;0.8" dur="2.5s" repeatCount="indefinite"/>
        </circle>

        <!-- Place name labels -->
        <text x="80" y="195" font-size="11" fill="rgba(50,60,80,0.7)" font-family="DM Sans,sans-serif" font-weight="600">Vasai East</text>
        <text x="220" y="210" font-size="11" fill="rgba(50,60,80,0.7)" font-family="DM Sans,sans-serif" font-weight="600">Kaman Gaon</text>
        <text x="520" y="180" font-size="9" fill="rgba(50,60,80,0.5)" font-family="DM Sans,sans-serif">NBUE 886 9</text>
        <text x="48" y="145" font-size="8" fill="rgba(50,60,80,0.45)" font-family="DM Mono,monospace">AT-30</text>

        <!-- Grid overlay very faint -->
        <line x1="0" y1="105" x2="700" y2="105" stroke="rgba(0,0,0,0.04)" stroke-width="1"/>
        <line x1="0" y1="210" x2="700" y2="210" stroke="rgba(0,0,0,0.04)" stroke-width="1"/>
        <line x1="0" y1="315" x2="700" y2="315" stroke="rgba(0,0,0,0.04)" stroke-width="1"/>
        <line x1="175" y1="0" x2="175" y2="420" stroke="rgba(0,0,0,0.04)" stroke-width="1"/>
        <line x1="350" y1="0" x2="350" y2="420" stroke="rgba(0,0,0,0.04)" stroke-width="1"/>
        <line x1="525" y1="0" x2="525" y2="420" stroke="rgba(0,0,0,0.04)" stroke-width="1"/>
      </svg>

      <!-- Chainage chips (HTML for sharp rendering) -->
      <div class="ch-chip" style="top:148px; left:128px;">CH 120+500</div>
      <div class="ch-chip" style="top:184px; left:226px;">CH 121+500</div>
      <div class="ch-chip" style="top:228px; left:170px;">CH 121+500</div>
      <div class="ch-chip" style="top:268px; left:138px;">CH 121+500</div>

      <!-- NH Badge -->
      <div class="nh-label" style="top:205px; right:165px;">NH 48</div>

      <!-- Map attribution -->
      <div class="map-attr">Leaflet | OpenStreetMap</div>

      <!-- Zoom controls -->
      <div class="map-zoom">
        <div class="zoom-btn" style="font-size:18px;font-weight:400;">+</div>
        <div class="zoom-btn" style="font-size:18px;font-weight:400;">−</div>
      </div>

      <!-- Left zoom cluster (from wireframe) -->
      <div style="position:absolute;right:10px;bottom:115px;display:flex;flex-direction:column;gap:3px;">
        <div class="zoom-btn" style="font-size:18px;font-weight:400;">+</div>
        <div class="zoom-btn" style="font-size:18px;font-weight:400;">−</div>
      </div>

      <!-- Side action buttons -->
      <div class="map-side-btns">
        <div class="map-action-btn" title="Layers">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M7 2L13 5L7 8L1 5Z"/><path d="M1 8l6 3 6-3"/><path d="M1 11l6 3 6-3"/>
          </svg>
        </div>
        <div class="map-action-btn" title="My location">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="7" cy="7" r="3"/><path d="M7 1v2M7 11v2M1 7h2M11 7h2"/>
          </svg>
        </div>
      </div>
    </div><!-- /map-canvas -->

    <!-- ══ BOTTOM PANELS ══ -->
    <div class="bottom-panels">

      <!-- Contractors -->
      <div class="bottom-card">
        <div class="bc-header">
          Contractors
          <div class="bc-badge">ℝ</div>
        </div>
        <div class="contractor-row">
          <div class="contractor-avatar" style="background:linear-gradient(135deg,#2563eb,#1d4ed8);">L</div>
          <span style="font-size:11px;font-weight:500;">Larsen & Toubro</span>
        </div>
        <div class="contractor-row">
          <div class="contractor-avatar" style="background:linear-gradient(135deg,#16a34a,#15803d);">A</div>
          <span style="font-size:11px;font-weight:500;">ABC Consultancy</span>
        </div>
      </div>

      <!-- Survey Data / Weather -->
      <div class="bottom-card">
        <div class="bc-header">Survey Data</div>
        <div class="weather-display">
          <div style="font-size:28px;line-height:1;">🌤</div>
          <div>
            <div class="weather-temp">32<sup>°C</sup></div>
          </div>
          <div class="weather-detail">
            Temp: 32°C<br>
            Rain: 0 mm
          </div>
        </div>
      </div>

      <!-- Alerts -->
      <div class="bottom-card">
        <div class="bc-header" style="justify-content:space-between;">
          Alerts
          <div style="display:flex;gap:4px;align-items:center;">
            <div style="font-size:9px;color:var(--text-muted);font-family:var(--mono);">8%↑</div>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="var(--text-muted)" stroke-width="1.5"><path d="M1 7l3-4 2 2 3-5"/></svg>
          </div>
        </div>
        <div class="alert-item">
          <div class="alert-dot" style="background:var(--accent-orange);"></div>
          <span>Excavator EX102 Idling 2 hours</span>
        </div>
        <div class="alert-item">
          <div class="alert-dot" style="background:var(--accent-red);"></div>
          <span>Soil Compaction Failure</span>
        </div>
      </div>

    </div><!-- /bottom-panels -->

  </div><!-- /map-center -->

  <!-- ════ RIGHT PANEL ════ -->
  <div class="right-panel">

    <div class="rp-header">
      <div class="rp-title">
        Project Details
        <div class="rp-title-actions">
          <div class="rp-icon-btn">?</div>
          <div class="rp-icon-btn">⚙</div>
          <div class="rp-icon-btn">−</div>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <div class="rp-tabs">
      <div class="rp-tab active">Progress</div>
      <div class="rp-tab">Tasks</div>
      <div class="rp-tab">BOQ</div>
      <div class="rp-tab">Reports</div>
    </div>

    <!-- Progress Section -->
    <div class="rp-section">
      <div class="rp-project-name">
        <span style="font-size:14px;font-weight:700;color:var(--text-h);">NH 48 Project</span>
        <div style="text-align:right;">
          <div class="rp-pct">45%</div>
          <div class="rp-pct-label">Complete</div>
        </div>
      </div>

      <div class="progress-bar" style="margin-bottom:5px;">
        <div class="progress-fill" style="width:45%;background:linear-gradient(90deg,#16a34a,#22c55e);"></div>
      </div>

      <div class="planning-row">
        <span class="planning-label">Planning</span>
        <div class="planning-dots">
          <div class="planning-dot filled"></div>
          <div class="planning-dot"></div>
        </div>
      </div>
    </div>

    <!-- Summary Table -->
    <div class="rp-section">
      <div style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:6px;">Summary:</div>
      <table class="summary-table">
        <tr>
          <td>Highway:</td>
          <td>NH 48</td>
        </tr>
        <tr>
          <td>Package:</td>
          <td>3 &nbsp;<span style="color:var(--accent-orange);font-weight:700;">+5</span></td>
        </tr>
        <tr>
          <td>Total Length:</td>
          <td>121.5 km</td>
        </tr>
        <tr>
          <td>Start Chainage (km):</td>
          <td>120+000</td>
        </tr>
        <tr>
          <td>End Chainage (km):</td>
          <td>141±500</td>
        </tr>
        <tr>
          <td>State:</td>
          <td>Maharashtra</td>
        </tr>
        <tr>
          <td>Contractor:</td>
          <td>Larsen & Toubro</td>
        </tr>
        <tr>
          <td>Budget:</td>
          <td>₹ 780 cr</td>
        </tr>
        <tr>
          <td>Consultants:</td>
          <td>ABC Consultants</td>
        </tr>
      </table>
    </div>

    <!-- Project Progress Bars -->
    <div class="rp-section">
      <div style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:8px;">Project Progress</div>

      <div class="prog-row">
        <div class="prog-label">Earthwork</div>
        <div class="prog-bar-wrap">
          <div class="prog-bar-fill" style="width:25%;background:#2563eb;"></div>
        </div>
        <div class="prog-pct">25%</div>
      </div>
      <div class="prog-row">
        <div class="prog-label">Culverts</div>
        <div class="prog-bar-wrap">
          <div class="prog-bar-fill" style="width:15%;background:#f59e0b;"></div>
        </div>
        <div class="prog-pct">15%</div>
      </div>
      <div class="prog-row">
        <div class="prog-label">Bridges</div>
        <div class="prog-bar-wrap">
          <div class="prog-bar-fill" style="width:10%;background:#6366f1;"></div>
        </div>
        <div class="prog-pct">10%</div>
      </div>
      <div class="prog-row">
        <div class="prog-label">Pavement</div>
        <div class="prog-bar-wrap">
          <div class="prog-bar-fill" style="width:5%;background:#ec4899;"></div>
        </div>
        <div class="prog-pct">5%</div>
      </div>
    </div>

    <!-- Mini Timeline Chart -->
    <div class="rp-section" style="padding-bottom:4px;">
      <div class="mini-chart">
        <svg width="100%" height="74" viewBox="0 0 240 74">
          <!-- Grid lines -->
          <line x1="0" y1="15" x2="240" y2="15" stroke="#e5e7eb" stroke-width="1"/>
          <line x1="0" y1="35" x2="240" y2="35" stroke="#e5e7eb" stroke-width="1"/>
          <line x1="0" y1="55" x2="240" y2="55" stroke="#e5e7eb" stroke-width="1"/>

          <!-- Planned line (dashed) -->
          <path d="M5,60 Q40,50 70,42 Q100,34 135,28 Q170,22 200,18 Q220,15 235,14"
                stroke="#9ca3af" stroke-width="1.5" fill="none" stroke-dasharray="4,3"/>

          <!-- Actual progress line -->
          <path d="M5,62 Q40,55 70,50 Q100,46 120,42"
                stroke="#2563eb" stroke-width="2" fill="none" stroke-linecap="round"/>

          <!-- Area fill under actual -->
          <path d="M5,62 Q40,55 70,50 Q100,46 120,42 L120,72 L5,72 Z"
                fill="rgba(37,99,235,0.08)"/>

          <!-- Data dots -->
          <circle cx="40" cy="54" r="3" fill="#2563eb" stroke="white" stroke-width="1.5"/>
          <circle cx="75" cy="49" r="3" fill="#2563eb" stroke="white" stroke-width="1.5"/>
          <circle cx="120" cy="42" r="4" fill="#2563eb" stroke="white" stroke-width="1.5"/>
          <circle cx="155" cy="38" r="3" fill="#9ca3af" stroke="white" stroke-width="1.5" stroke-dasharray="2,1"/>
          <circle cx="195" cy="28" r="3" fill="#9ca3af" stroke="white" stroke-width="1.5"/>
          <circle cx="225" cy="19" r="3" fill="#9ca3af" stroke="white" stroke-width="1.5"/>
        </svg>
      </div>
      <div class="mc-x-labels">
        <span>Act</span><span>Apt</span><span>May</span><span>Apt</span><span>Moo</span><span>Jul</span><span>Aur</span>
      </div>
    </div>

  </div><!-- /right-panel -->

</div><!-- /body-layout -->

<!-- ══════════════ STATUS BAR ══════════════ -->
<div class="status-bar">
  <div class="sb-item">
    <div class="sb-dot connected"></div>
    <span>Status: Connected</span>
  </div>
  <div class="sb-item">
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5"><ellipse cx="5" cy="5" rx="4" ry="4"/><path d="M5 1v1M5 8v1M1 5h1M8 5h1"/></svg>
    <span>PostgreSQL</span>
  </div>
  <div class="sb-spacer"></div>

  <!-- Coordinate ruler ticks -->
  <div class="sb-ticks">
    <div class="sb-tick"></div><div class="sb-tick"></div><div class="sb-tick"></div>
    <div class="sb-tick" style="height:12px;background:rgba(255,255,255,0.35);"></div>
    <div class="sb-tick"></div><div class="sb-tick"></div>
    <div class="sb-tick" style="height:12px;background:rgba(255,255,255,0.35);"></div>
    <div class="sb-tick"></div><div class="sb-tick"></div><div class="sb-tick"></div>
    <div class="sb-tick" style="height:12px;background:rgba(255,255,255,0.35);"></div>
    <div class="sb-tick"></div><div class="sb-tick"></div>
  </div>

  <!-- Scale labels -->
  <div class="sb-item" style="gap:3px;">
    <span>1</span>
    <div style="width:24px;height:1px;background:rgba(255,255,255,0.35);"></div>
    <span>1</span>
    <span>T</span>
    <span>T</span>
    <span>T</span>
  </div>

  <div class="sb-item">
    <span>GII 2028</span>
  </div>

  <!-- Progress bar segment -->
  <div style="width:60px;height:8px;background:rgba(255,255,255,0.08);border-radius:1px;overflow:hidden;display:flex;">
    <div style="width:55%;background:rgba(37,99,235,0.7);"></div>
  </div>

  <div class="sb-item">
    <span style="color:rgba(255,255,255,0.5);">▓▓▓▓▓░░░░░░░░░░░</span>
  </div>

  <div class="sb-item" style="color:var(--nhai-gold);font-weight:600;">
    <span>15000</span>
  </div>
</div>